import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import GlobalMultiSelectNew from "../../../components/mui/GlobalMultiSelectNew";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getCrolistunderCrm,
  getReplacedDetailedView,
  getTrcrmlist,
} from "../../../redux/features/srtSlice";
import { TR_CRO_VIEW_HEAD } from "../../../components/datagrid/srt/TrCroTable";
import GlobalMultiSelectId from "../../../components/mui/GlobalMultiSelectId";

const TrtCroview = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fromdate = searchParams.get("fromDate");
  const projectId = searchParams.get("projectId");
  const todate = searchParams.get("toDate");

  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const [selectedCRM, setSelectedCRM] = useState([]);
  const [selectedCRO, setSelectedCRO] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate("");

  const { replaceddetaildata, loading, crmlisttr, crolistundercrm } =
    useSelector((state) => state.srt);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  useEffect(() => {
    dispatch(getTrcrmlist(projectId));
  }, []);

  const data = {
    projectId: projectId || 1,
    page: pageNum,
    limit: gridSize,
    fromDate: fromDate,
    toDate: toDate,
    crmId: selectedCRM,
    croId: selectedCRO,
  };

  useEffect(() => {
    dispatch(getReplacedDetailedView(data));
  }, [
    pageNum,
    gridSize,
    fromDate,
    toDate,
    projectId,
    selectedCRM,
    selectedCRO,
  ]);

  const crmdata = {
    crmId: selectedCRM,
  };

  useEffect(() => {
    if (selectedCRM.length > 0) {
      dispatch(getCrolistunderCrm(crmdata));
    } else {
      setSelectedCRO([]);
    }
  }, [selectedCRM]);

  return (
    <GlobalWrapper title={"Replacement Report"}>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: "10px",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        {projectId ? (
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
            }}
          >
            <GlobalMultiSelectId
              disabled={loading}
              label={"CRM"}
              arrayState={selectedCRM}
              arraySetState={setSelectedCRM}
              data={crmlisttr}
              keys={{ id: "crmName", value: "crmId" }}
            />
            <GlobalMultiSelectId
              disabled={loading}
              label={"CRO"}
              arrayState={selectedCRO}
              arraySetState={setSelectedCRO}
              data={crolistundercrm}
              keys={{ id: "name", value: "userID" }}
            />
          </Box>
        ) : null}
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={TR_CRO_VIEW_HEAD(navigate, fromDate, toDate, projectId)}
          rows={replaceddetaildata.data}
          meta={replaceddetaildata?.meta?.totalRecords || 0}
          rowUniqueId="croId"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default TrtCroview;
